import { render, staticRenderFns } from "./right-arrow-red.vue?vue&type=template&id=0628b2ca&scoped=true&"
import script from "./right-arrow-red.vue?vue&type=script&lang=js&"
export * from "./right-arrow-red.vue?vue&type=script&lang=js&"
import style0 from "./right-arrow-red.vue?vue&type=style&index=0&id=0628b2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0628b2ca",
  null
  
)

export default component.exports